import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupDisbandContentProps } from './msg-group-disband-content';
import { MsgGroupDisbandContent } from './msg-group-disband-content';

export interface MsgGroupDisbandPreviewProps extends MsgGroupDisbandContentProps {}

export const MsgGroupDisbandPreview = memo(function MsgGroupDisbandPreview({
  message,
}: MsgGroupDisbandPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupDisbandContent message={message} />
    </LastMessageSystem>
  );
});
